import React from 'react';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { ContentList } from '../../../_lib/components/ContentList';
import { isNotNull } from '../../../lib/typeGuards';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type CategoriesListProps<T> = {
  categories: T[];
  children: (category: T) => React.ReactElement | null;
};

/**
 * List of category items, written to be composable with any number of children.
 * each category must be mapped with CategoriesListItem.
 */
export function CategoriesList<T>({ categories, children }: CategoriesListProps<T>) {
  const { t } = useSonTranslation('Categories');
  return categories?.length <= 0
    ? (
        <ContentMessage text={t('noCategoriesAvailable')} />
      )
    : (
        <ContentList>{categories.map(category => children(category)).filter(isNotNull)}</ContentList>
      );
}
